import React, { Component } from 'react';

class NotFound extends Component {
  render() {
    return (
      <div className="NotFound">
        Not Found
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound/NotFound.js